<div *ngIf="cartItem.fabricProductPreview"
	 class="cart-item cart-item-fabric flex justify-between items-start w-full gap-3">
	<a [href]="'/product/fabric-product/' + cartItem.fabricProductPreview.product.slug">
		<img *ngIf="cartItem.productGroup !== 'swatch'" class="cart-item-image"
			 [src]="cartItem.fabricProductPreview.product.heroImage"
			 [alt]="cartItem.fabricProductPreview.product.name">
		<div *ngIf="cartItem.productGroup === 'swatch'"
			 class="swatch-wrapper">
			<div class="custom-border" [ngStyle]="{'background': 'url(' + cartItem.fabricProductPreview.product.heroImage + ')'}">
			</div>
		</div>
	</a>

	<div class="flex flex-[68%] items-start gap-2">
		<div class="w-full flex justify-between items-start gap-2">
			<div class="w-full flex-[97%] flex flex-col">
				<h2 class="text-sm md:text-base font-medium">{{cartItem.productGroup === 'swatch' ? 'Swatch -' : ''}} {{cartItem.fabricProductPreview.product.name}}</h2>
				<p *ngIf="cartItem.selectedFabric && cartItem.productGroup !== 'swatch'" class="text-xs md:text-sm text-[#3c3c3c]">Selected Fabric: {{cartItem.selectedFabric.product.name | truncketHtml: 40}}</p>
				<p *ngIf="cartItem.selectedSizeOption"
				   class="text-xs md:text-sm text-[#3c3c3c]">{{ cartItem.sizeDisplayName? cartItem.sizeDisplayName : 'Selected Size' }}: {{cartItem.selectedSizeOption.label | truncketHtml: 40}}</p>
				<p *ngIf="cartItem.customSize"
				   class="text-xs md:text-sm text-[#3c3c3c] capitalize">{{prepareCustomSizeLabel(cartItem.customSize || '').toLowerCase()}}</p>
				<p *ngIf="cartItem.selectedFinishList && cartItem.selectedFinishList.length > 0"
				   class="text-xs md:text-sm text-[#3c3c3c]">{{ cartItem.finishDisplayName? cartItem.finishDisplayName : 'Selected Finish' }}:
					<span *ngFor="let finish of cartItem.selectedFinishList; let i = index" class="capitalize">
					{{finish.label.toLowerCase()}}<ng-container *ngIf="i!=(cartItem.selectedFinishList!.length - 1)">, </ng-container>
				</span>
				</p>
				<p *ngIf="!cartItem.calculatedDiscountPrice" class="text-base black-text font-bold mb-3">
					<span class="text-xs mr-0.5 grey-text">{{selectedCurrency | uppercase}}</span> {{cartItem.calculatedPrice || cartItem.fabricProductPreview.product.price | currencyConverter | number:'1.2-2'}}<span class="text-xs ml-0.5 grey-text">/ {{cartItem.unit}}</span>
				</p>
				<div *ngIf="cartItem.calculatedDiscountPrice" class="flex justify-start items-center font-bold flex-wrap">
					<span class="text-xs mr-0.5 grey-text">{{selectedCurrency | uppercase}}</span>
					<p class="line-through text-sm text-[#898E9A]">
						 {{cartItem.calculatedPrice || cartItem.fabricProductPreview.product.price | currencyConverter | number:'1.2-2'}}
					</p>
					<div class="text-base black-text ml-1">{{(cartItem.calculatedDiscountPrice || cartItem.fabricProductPreview.product.price) |  currencyConverter | number: '1.0-2'}}</div>
					<span class="text-xs ml-0.5 grey-text">/ {{cartItem.unit}}</span>
				</div>
				<fb-cart-quantity-input [product]="cartItem.fabricProductPreview.product"
										[minOrderQuantity]="minimumOrderQuantity"
										[cartItem]="cartItem"
										[calculatedQuantityInStock]="quantityInStock"
										[quantity]="cartItem.quantity"
										(quantityChange)="updateCartItemQuantity($event)"></fb-cart-quantity-input>
			</div>
			<div class="w-full flex-[3%] flex flex-col items-center gap-y-2">
				<button (click)="deleteCartItem(cartItem.id, cartItem.fabricProductPreview.product.sku,true)"
						class="cursor-pointer relative right-0">
					<span class="material-symbols-outlined delete">
						delete
					</span>
				</button>
				<button (click)="moveToWishlist(cartItem.id, cartItem.fabricProductPreview.product.sku, cartItem.fabricProductPreview.product.name)"
						class="cursor-pointer relative right-0">
					<span class="material-symbols-outlined delete">
						bookmark_heart
					</span>
				</button>
			</div>

		</div>

	</div>
</div>
<div *ngIf="cartItem.finishedProductPreview"
	 class="cart-item flex justify-between items-start w-full gap-3">
	<a [href]="'/product/finished-product/' + cartItem.finishedProductPreview.product.slug">
		<img class="cart-item-image cart-item-finished"
			 [src]="cartItem.finishedProductPreview.product.heroImage"
			 [alt]="cartItem.finishedProductPreview.product.name">
	</a>

	<div class="flex flex-[68%] items-start gap-2">
		<div class="w-full flex justify-between items-start gap-2">
			<div class="w-full flex-[97%] flex flex-col">
				<h2 class="text-sm md:text-base font-medium">{{cartItem.finishedProductPreview.product.name}}</h2>
				<p *ngIf="cartItem.selectedFabric"
				   class="text-xs md:text-sm text-[#3c3c3c]">Selected Fabric: {{cartItem.selectedFabric.product.name | truncketHtml: 40}}</p>
				<p *ngIf="cartItem.selectedSizeOption"
				   class="text-xs md:text-sm text-[#3c3c3c]">{{ cartItem.sizeDisplayName? cartItem.sizeDisplayName : 'Selected Size' }}: {{cartItem.selectedSizeOption.label | truncketHtml: 40}}</p>
				<p *ngIf="cartItem.customSize"
				   class="text-xs md:text-sm text-[#3c3c3c] capitalize">{{prepareCustomSizeLabel(cartItem.customSize || '').toLowerCase()}}</p>
				<p *ngIf="cartItem.selectedFinishList && cartItem.selectedFinishList.length > 0"
				   class="text-xs md:text-sm text-[#3c3c3c]">{{ cartItem.finishDisplayName? cartItem.finishDisplayName : 'Selected Finish' }}:
					<span *ngFor="let finish of cartItem.selectedFinishList; let i = index" class="capitalize">
					{{finish.label.toLowerCase()}}<ng-container *ngIf="i!=(cartItem.selectedFinishList!.length - 1)">, </ng-container>
				</span>
				</p>
				<p *ngIf="!cartItem.calculatedDiscountPrice" class="text-base black-text font-bold mb-3">
					<span class="text-xs mr-0.5 grey-text">{{selectedCurrency | uppercase}}</span> {{cartItem.calculatedPrice || cartItem.finishedProductPreview.product.price | currencyConverter | number:'1.2-2'}}<span class="text-xs ml-0.5 grey-text">/ {{cartItem.unit}}</span>
				</p>
				<div *ngIf="cartItem.calculatedDiscountPrice" class="flex justify-start items-center font-bold">
					<span class="text-xs mr-0.5 grey-text">{{selectedCurrency | uppercase}}</span>
					<p class="line-through text-sm text-[#898E9A]">
						{{cartItem.calculatedPrice || cartItem.finishedProductPreview.product.price | currencyConverter | number:'1.2-2'}}
					</p>
					<div class="text-base black-text ml-1">{{(cartItem.calculatedDiscountPrice || cartItem.finishedProductPreview.product.price) |  currencyConverter | number: '1.0-2'}}</div>
					<span class="text-xs ml-0.5 grey-text">/ {{cartItem.unit}}</span>
				</div>
				<fb-cart-quantity-input [product]="cartItem.finishedProductPreview.product"
										[minOrderQuantity]="minimumOrderQuantity"
										[cartItem]="cartItem"
										[calculatedQuantityInStock]="quantityInStock"
										[quantity]="cartItem.quantity"
										(quantityChange)="updateCartItemQuantity($event)"></fb-cart-quantity-input>
			</div>
			<div class="w-full flex-[3%] flex flex-col items-center gap-y-2">
				<button (click)="deleteCartItem(cartItem.id, cartItem.finishedProductPreview.product.sku,true)" class="cursor-pointer relative right-0">
					<span class="material-symbols-outlined delete">
						delete
					</span>
				</button>
				<button (click)="moveToWishlist(cartItem.id, cartItem.finishedProductPreview.product.sku, cartItem.finishedProductPreview.product.name)"
						class="cursor-pointer relative right-0">
					<span class="material-symbols-outlined delete">
						bookmark_heart
					</span>
				</button>
			</div>

		</div>

	</div>
</div>
